export default {
  SET_ERROR(state, error) {
    state.state = error.state;
    state.message = error.message;
  },
  RESET_ERROR(state) {
    state.state = false;
    state.message = '';
  }
};
